import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useAuth } from '../contexts/AuthContext';
import './FloatingUserPill.css';

const FloatingUserPill = () => {
  const { user, logout } = useAuth();

  if (!user) return null;

  // Extract first letter of email or name for avatar
  const initial = user.email ? user.email.charAt(0).toUpperCase() : '?';

  return (
    <AnimatePresence>
      <motion.div 
        className="floating-user-pill"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, scale: 0.9 }}
        transition={{ duration: 0.3, ease: 'easeOut' }}
      >
        <div className="floating-user-pill__avatar">{initial}</div>
        <div className="floating-user-pill__info">
          <span className="floating-user-pill__email">{user.email}</span>
          <button className="floating-user-pill__logout" onClick={logout}>
            Sign Out
          </button>
        </div>
      </motion.div>
    </AnimatePresence>
  );
};

export default FloatingUserPill;
